// extracted by mini-css-extract-plugin
module.exports = {"EditorEmarsysEmail":"EditorEmarsysEmail_EditorEmarsysEmail__Y6DiD"};